'use strict';

const withProps = require('./with_props');

const BaseView = withProps(Backbone.View);
BaseView.extend = function(config) {
    return withProps(Backbone.View.extend(config));
};

module.exports = BaseView;
